unit App.Config;

interface

type
  TAppConfig = class
  private
    FBaseUrl: string;
    FAuthURL: string;
    FSphinxClientId: string;
    FRegisterURL: string;
    FMaxSession: Integer;
  public
    constructor Create;
    procedure Load(AResponse: string);
    function CleanSphinxRedirectUri(const APath: string): string;
    property BaseUrl: string read FBaseUrl write FBaseUrl;
    /// <summary>
    /// for Sphinx based Systems this points to the Sphinx Server
    /// </summary>
    property AuthURL: string read FAuthURL write FAuthURL;
    property RegisterURL: string read FRegisterURL write FRegisterURL;
    property SphinxClientId: string read FSphinxClientId write FSphinxClientId;
    property MaxSession: Integer read FMaxSession write FMaxSession;
  end;

function AppConfig: TAppConfig;

implementation

uses
  System.SysUtils,
  JS,
  XData.Web.Connection,
  XData.Web.Request;

var
  FAppConfig: TAppConfig;

function AppConfig: TAppConfig;
begin
  if not Assigned(FAppConfig) then
    FAppConfig := TAppConfig.Create;
  Result := FAppConfig;
end;

{ TAppConfig }

function TAppConfig.CleanSphinxRedirectUri(const APath: string): string;
var
  I: Integer;
begin
  Result := APath;
  I := Result.IndexOf('?');
  if I > 0 then
    Result := Result.Substring(0, I);
  I := Result.IndexOf('#');
  if I > 0 then
    Result := Result.Substring(0, I);
end;

constructor TAppConfig.Create;
begin
  FBaseUrl := '';
  FAuthURL := '';
end;

procedure TAppConfig.Load(AResponse: string);
var
  Obj: TJSObject;
begin
  Obj := TJSObject(TJSJSON.parse(AResponse));

  if JS.toString(Obj['BaseUrl']) <> '' then
    FBaseUrl := JS.toString(Obj['BaseUrl']);

  if JS.toString(Obj['AuthUrl']) <> '' then
    FAuthURL := JS.toString(Obj['AuthUrl']);

  if FAuthURL = '' then
    FAuthURL := FBaseUrl;

  if JS.toString(Obj['RegisterUrl']) <> '' then
    FRegisterURL := JS.toString(Obj['RegisterUrl'])
  else
    FRegisterURL := FBaseUrl;

  FSphinxClientId := JS.toString(Obj['SphinxId']);

  if Obj.hasOwnProperty('MaxSession') then
     FMaxSession := JS.toInteger(Obj['MaxSession'])
  else
     FMaxSession := 60;

end;

end.
